import NewMember from "../../../../components/@users/members/NewMember";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

import { ownerTypes } from "../../../../schema/users/memberSchema";

import { useAuthAccess } from "../../../../hooks/useAuthAccess";

export default function MemberNewPage() {

    const { authData } = useAuthAccess()

    // console.log('authData', authData)

    let ownerId = authData?.profile?.user?.id

    return (
        <MemberNewPage 
            routeType={routeTypes.retail}
            ownerType={ownerTypes.retailer}
            ownerId={ownerId}
        />
    )
}       